// Factories
import { BaseServiceFactory } from "../../base/factories/BaseServiceFactory";
/**
 * MetaOS service factory boundary.
 * Shared service wiring is inherited; add only MetaOS-specific provider overrides here.
 */
export class MetaOSAppServiceFactory extends BaseServiceFactory {
}
